module.exports = __webpack_public_path__ + "img/czuchry.c93859d1.jpg";